import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-stop-onboarding',
  templateUrl: './stop-onboarding.component.html',
  styleUrls: ['./stop-onboarding.component.scss'],
  imports: [MatButton, RouterLink, MatIcon]
})
export class StopOnboardingComponent implements OnInit {
  @Input() heading: string = 'Title';
  @Input() content: string = 'no data available';
  @Input() content1: string = 'Try searching again';
  @Input() navigateTo: string = ''; // Default route
  @Input() IsShow: boolean = false;
  @Input() IsShowEmail: boolean = false;
  @Input() email: string = ''
  @Output() myEvent = new EventEmitter<string>();

  fetchMatchedEmail: string = ''

  emitEvent() {
    this.myEvent.emit(this.navigateTo);
  }

  AddNow() {
    this.emitEvent();
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.fetchMatchedEmail = this.email
  }


}
